import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("ux-collapsible", () => {
    it("should match snapshot in collapsed state", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-collapsible button-text-collapsed="Show Details"
                                  button-text-expanded="Hide Details">Test Content</ux-collapsible>`
        );
        const el = await page.find("ux-collapsible");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should match snapshot in expanded state", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-collapsible is-expanded button-text-collapsed="Show Details"
                                  button-text-expanded="Hide Details">Test Content</ux-collapsible>`
        );
        const el = await page.find("ux-collapsible");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should change state, render aria attributes and fire events correctly if button is clicked", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-collapsible button-text-collapsed="Show Details"
                                  button-text-expanded="Hide Details"></ux-collapsible>`
        );
        const eventHandler = await page.spyOnEvent("uxCollapsibleExpanded");
        const el = await page.find("ux-collapsible");
        const content = await page.find(".ux-collapsible-content__inner");
        const btn = await page.find(".ux-collapsible-button");
        const btnLabel = await page.find(".ux-collapsible-button__label");
        // default state
        expect(el).toHaveClass("hydrated");
        expect(el).not.toHaveAttribute("is-expanded");
        expect(content).toHaveAttribute("aria-hidden");
        expect(btnLabel.innerText).toEqual("Show Details");
        // click to expand
        await btn.click();
        expect(eventHandler).toHaveReceivedEventDetail(true);
        await page.waitForChanges();
        expect(el).toHaveAttribute("is-expanded");
        expect(content).not.toHaveAttribute("aria-hidden");
        expect(btnLabel.innerText).toEqual("Hide Details");
        // click to collapse
        await btn.click();
        expect(eventHandler).toHaveReceivedEventDetail(false);
        await page.waitForChanges();
        expect(el).not.toHaveAttribute("is-expanded");
        expect(content).toHaveAttribute("aria-hidden");
        expect(btnLabel.innerText).toEqual("Show Details");
    });

    it("should render valid html", async () => {
        await testValidHtml(
            `<ux-collapsible button-text-collapsed="Show Details"
                                  button-text-expanded="Hide Details"></ux-collapsible>`
        );
    });
});
